export const LINK_TYPES = {
  PATIENT_FACING: "patient-facing",
  STAFF_SCHEDULING: "staff-scheduling",
} as const;

export const INTERSTITIAL_VARIANTS = {
  QUESTION_AND_CONTEXT: "question_and_context",
  ONLY_CONTEXT: "only_context",
  CONTROL: "control",
} as const;

export const NIRVANA_VARIANTS = {
  CONTROL: "control",
  NIRVANA: "nirvana",
} as const;

export const BANNER_VARIANTS = {
  VISIT_COVERED: "visit_covered",
  VISIT_NOT_COVERED: "visit_not_covered",
  PLAN_NOT_RETURNED: "plan_not_returned",
  NO_BANNER: "no_banner",
} as const;

export type BannerVariant =
  (typeof BANNER_VARIANTS)[keyof typeof BANNER_VARIANTS];

export const BOOKING_FLOW_EVENTS = {
  SCHEDULE_ENTRY_PAGE: "scheduleEntryPage",
  SCHEDULE_CONTINUATION_PAGE: "scheduleContinuationPage",
  INSURANCE_PAGE_VIEWED_AT: "insurancePageViewedAt",
  INSURANCE_PAGE_SUBMITTED_AT: "insurancePageSubmittedAt",
  EMAIL_EXIT_PAGE_VIEWED_AT: "emailExitPageViewedAt",
  EMAIL_EXIT_PAGE_SUBMITTED_AT: "emailExitPageSubmittedAt",
  SCHEDULING_PAGE_VIEWED_AT: "schedulingPageViewedAt",
  APPOINTMENT_SLOT_SUBMITTED_AT: "appointmentSlotSubmittedAt",
  EMAIL_CONTINUE_PAGE_VIEWED_AT: "emailContinuePageViewedAt",
  PATIENT_INFO_PAGE_VIEWED_AT: "patientInfoPageViewedAt",
  PROVIDER_ID: "providerId",
  SELECTED_APPOINTMENT_SLOT: "selectedAppointmentSlot",
  STATE_ID: "stateId",
  INSURANCE_ID: "insuranceId",
  IS_OTHER_STATE: "isOtherState",
  IS_NOT_LISTED_INSURANCE: "isNotListedInsurance",
  ENTER_INSURANCE_INFO: "enterInsuranceInfo",
  INTERSTITIAL_VARIANT: "interstitialVariant",
  INTERSTITIAL_GOAL_SELECTIONS: "interstitialGoalSelections",
  INTERSTITIAL_QUESTION_PAGE_VIEWED_AT: "interstitialQuestionPageViewedAt",
  INTERSTITIAL_QUESTION_PAGE_SUBMITTED_AT:
    "interstitialQuestionPageSubmittedAt",
  INTERSTITIAL_INFO_PAGE_VIEWED_AT: "interstitialInfoPageViewedAt",
  INTERSTITIAL_INFO_PAGE_SUBMITTED_AT: "interstitialInfoPageSubmittedAt",
  NIRVANA_VARIANT: "nirvanaVariant",
  DEMOGRAPHIC_INFO_PAGE_VIEWED_AT: "demographicInfoPageViewedAt",
  DEMOGRAPHIC_INFO_PAGE_SUBMITTED_AT: "demographicInfoPageSubmittedAt",
  NIRVANA_LOADING_SCREEN_VIEWED_AT: "nirvanaLoadingScreenViewedAt",
  BANNER_VARIANT: "bannerVariant",
} as const;

export type { FillOption as EnterInsuranceInfo } from "../scheduling/constants";
